import Axios from 'axios';
import * as React from 'react';
import ReactMarkdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface Props { path: string; }
interface State { md?: string }

const components: Components = {
  code({ className, children, ...rest }) {
    return (
      <pre style={{ padding: 3, border: 'solid 1px #eee' }}>
        <code className={className} {...rest}>{children}</code>
      </pre>
    );
  }
};

export class MarkdownContent extends React.Component<Props, State>{

  state: State = {

  };

  setFail() {
    this.setState({ md: `~~~
CONTENT NOT FOUND: ${this.props.path}
~~~` });
  }

  componentDidMount() {
    Axios.get(this.props.path).then((response) => {
      if (response.status != 200)
        this.setFail();
      else
        this.setState({ md: response.data });
    }, (reason) => {
      this.setFail();
    })
  }

  render() {
    if (!this.state.md) {
      return <p>...</p>;
    }
    return (
      <div className="rich-content">
        <ReactMarkdown components={components} remarkPlugins={[remarkGfm]}>{this.state.md}</ReactMarkdown>
      </div>
    );
  }
}
